

import { Category } from '~/node_modules/sitisjs/dist/internal/sections/categories/models/Category';
import ProductPageGallery from '~/components/product/ProductPageGallery.vue';
import SPage from '~/components/page/SPage';
import CharacteristicsList from '~/components/product/CharacteristicsList.vue';
import AddToCardBtn from '~/components/widgets/AddToCardBtn/AddToCardBtn.vue';
import { ObserveVisibility } from 'vue-observe-visibility';
import errorParseNetwork from '~/helpers/errorParseNetwork';
import AddBuyOneClickBtn from '~/components/widgets/AddBuyOneClickBtn/AddBuyOneClickBtn.vue';
import ProductMixin from '../../node_modules/sitis-nuxt/lib/mixins/ProductMixin';

export default {
  name: 'ProductPage',

  data() {
    return {
      filterPagesLocal: [],
      variantsName: [],

      isLoading: false,
    };
  },
  components: {
    AddToCardBtn,
    SPage,
    CharacteristicsList,
    ProductMainCardLoad: () => import('~/components/product/ProductMainCardLoad.vue'),
    ProductTabsInfo: () => import('~/components/product/ProductInfo.vue'),
    // MainInfoCard: () => import('~/components/product/MainInfoCard'),
    ProductPageGallery,
    ProductWithPay: () => import('~/components/product/ProductWithPay'),
    ParseVariantsName: () => import('~/components/product/product-info/ParseVariantsName.vue'),
    // SliderProducts: () => import('~/components/catalog/SliderProducts'),
    AddBuyOneClickBtn,
  },

  mixins: [ProductMixin],

  computed: {
    name() {
      return `${this.product?.name} ${this?.product?.code || ''}` || '';
    },
    breadcrumbsList() {
      const breadcrumbs = this.breadcrumbs || [];

      breadcrumbs.push({
        title: this?.currentProduct?.code || '',
        path: this?.currentProduct?.url || '',
      });

      return breadcrumbs;
    },
    getImgPath() {
      const { product } = this;

      if (!product?.imageId) {
        return 'og:image';
      }

      return this.$img(String(product.imageId || 0), {
        width: 1000,
        format: 'jpg',
      });
    },

    activeCategorySlug() {
      return '';
    },

    getCharacteristics() {
      const product = this.product?.characteristics || [];

      return product.map((t) => t);
    },

    extensions() {
      return ['characteristicGroup', 'modifications'];
    },

    // imageAlt() {
    //   const pathNumber = this.product?.code;
    //   const sets = this.product?.characteristicGroup?.name;
    //   const manufacturer = this.allCharacteristics.find((t) => t.slug === 'manufacturer')?.values?.[0]?.value || '';
    //
    //   return [
    //     pathNumber,
    //     sets,
    //     manufacturer,
    //   ].filter((t) => !!t).join(' ');
    // },
    // imageTitle() {
    //   const pathNumber = this.product?.code;
    //   const sets = this.product?.characteristicGroup?.name;
    //   const manufacturer = this.allCharacteristics.find((t) => t.slug === 'manufacturer')?.values?.[0]?.value || '';
    //
    //   return [
    //     pathNumber,
    //     sets,
    //     manufacturer,
    //     this.product?.name,
    //   ].filter((t) => !!t).join(' ');
    // },
    //
    // sameProductsTitle() {
    //   return [
    //     this.product.code,
    //     this.product.name,
    //   ].filter((t) => !!t).join(' ');
    // },
  },
  directives: {
    ObserveVisibility,
  },

  asyncData(context) {
    const host = context?.req?.headers?.host || window?.location.host || '';
    return { host };
  },
  head() {
    return this.getHead();
  },

  // watch: {
  //   async product() {
  //     await this.getVariants();
  //   },
  // },

  methods: {
    // async getAllOtherProducts() {
    //   if (!this.product?.slug) {
    //     return;
    //   }
    //   await this.getRelatedProducts(this.product.slug);
    //   await this.getSameProducts(this.product.slug);
    //   await this.getRecentlyProducts();
    // },
    openPopupSmeta() {
      this.$store.commit('pop-up-smeta/open', {
        isShowTextContent: true,
        isShowComments: true,
        title: 'Изготовить ЖБИ по индивидуальному размеру и чертежу',
      });
    },
    async getVariants() {
      const id = this?.product?.id;

      const response = await this.$api.agent.transport
        .get(`product/codes?product_id=${id}`)
        .then((res) => res.data)
        .catch((err) => ({ error: errorParseNetwork(err.response) }));

      if (response.error) {
        console.log('Запрос варианта написания:', response.error);
        return;
      }

      this.variantsName = response;
    },

    visibilityChanged(isVisible, entry) {
      if (isVisible) {
        this.getRelatedProducts(this.slug);
        this.getSameProducts(this.slug);
        this.getRecentlyProducts();
      }
    },
    async getListLandingPages() {
      let filterPages = await this.$api.agent.transport
        .get('/filter-pages').then((res) => res.data).catch(() => []);

      filterPages = filterPages.map((category) => new Category(category));

      this.filterPagesLocal = filterPages;
    },

    getHead() {
      return {
        title: this?.product?.seo?.title,
        meta: [
          {
            hid: 'metadescription',
            name: 'description',
            content: this?.product?.seo?.description || 'description',
          },
          { name: 'keywords', content: this?.product?.seo?.keywords || 'keywords' },

          {
            hid: 'og:type',
            property: 'og:type',
            content: 'product',
          },
          {
            hid: 'og:title',
            property: 'og:title',
            content: this?.product?.seo?.title || 'og:title',
          },
          {
            hid: 'og:site_name',
            property: 'og:site_name',
            content: 'Бетонстрой',
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: this?.product?.seo?.description || 'og:description',
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.getImgPath,
          },
          {
            hid: 'og:url',
            property: 'og:url',
            content: `https://${this.host}${this.product?.url}`,
          },
          {
            hid: 'twitter:description',
            name: 'twitter:description',
            content: this?.product?.seo?.description || 'og:description',
          },
          {
            hid: 'twitter:image',
            name: 'twitter:image',
            content: this.getImgPath,
          },
          {
            hid: 'twitter:title',
            name: 'twitter:title',
            content: this?.product?.seo?.title || 'og:title',
          },
          {
            hid: 'twitter:card',
            name: 'twitter:card',
            content: 'summary_large_image',
          },
        ],
      };
    },
  },

  async mounted() {
    this.isLoading = true;
    // await this.getAllOtherProducts();
    await this.getListLandingPages();
    this.isLoading = false;
    await this.getVariants();
  },

};
